import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// import auth from 'ThreeTerminal_base/auth';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import CommentTextarea from './commentTextarea/';

class ParentComment extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        order: PropTypes.number,
        loginId: PropTypes.string,
        userInfo: PropTypes.object,
        myComUrl: PropTypes.string,
    };

    state = {
        showPCommentInput: false,
    };

    handleShowInput = () => {
        this.setState({ showPCommentInput: !this.state.showPCommentInput });
    };

    render() {
        const {
            content: { doc_url, doc_name, comment_id, uname, user_id, ip_from, contents, comment_date },
            order,
            loginId,
            userInfo,
            myComUrl,
        } = this.props;
        const { showPCommentInput } = this.state;
        const pCommentConfig = {
            cmtLength: 1000,
            docUrl: doc_url,
            docTitle: doc_name,
            quote_id: comment_id,
        };

        return (
            <div className={styles.pCommentItem}>
                <div className={styles.pCommentBlock}>
                    <span className={styles.pOrder}>{order + 1}</span>
                    <div className={styles.userName}>
                        <a href={`${location.origin}/myComments?guid=${user_id}`} target="_blank">
                            {uname}
                        </a>
                        <span className={styles.location}>[{ip_from}网友]</span>
                    </div>
                    <p className={styles.contentTxt} dangerouslySetInnerHTML={{ __html: contents }} />
                    <div className={styles.bottomBar}>
                        <span className={styles.commentDate}>{comment_date}</span>
                        <div className={styles.replayBtn} onClick={this.handleShowInput}>
                            {showPCommentInput ? '取消' : '回复'}
                        </div>
                    </div>
                    {showPCommentInput ? (
                        <div className={styles.commentInput}>
                            <CommentTextarea
                                loginId={loginId}
                                config={pCommentConfig}
                                userInfo={userInfo}
                                myComUrl={myComUrl}
                            />
                        </div>
                    ) : null}
                </div>
                <div className={styles.bottomLine} />
            </div>
        );
    }
}

/**
 * 定义 CommentItem 组件
 */
class CommentItem extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        userInfo: PropTypes.object,
        myComUrl: PropTypes.string,
        loginId: PropTypes.string,
    };

    state = {
        showCommentInput: false,
    };

    handleShowInput = () => {
        this.setState({ showCommentInput: !this.state.showCommentInput });
    };

    renderParent = parent => {
        const { userInfo, myComUrl, loginId } = this.props;
        const reserveDom = [];

        if (Object.prototype.toString.call(parent) === '[object Array]') {
            for (let i = parent.length; i > 0; i--) {
                reserveDom.push(
                    <ParentComment
                        content={parent[i - 1]}
                        key={i}
                        order={i - 1}
                        loginId={loginId}
                        userInfo={userInfo}
                        myComUrl={myComUrl}
                    />,
                );
            }
        }

        return reserveDom;
    };

    render() {
        const {
            content: {
                comment_id,
                doc_url,
                doc_name,
                uname,
                user_id,
                ip_from,
                contents,
                parent,
                comment_date,
                permalink,
            },
            userInfo,
            myComUrl,
            loginId,
        } = this.props;
        const { showCommentInput } = this.state;

        const commentConfig = {
            cmtLength: 1000,
            docUrl: doc_url,
            docTitle: doc_name,
            quote_id: comment_id,
        };

        return (
            <div className={styles.commentItem}>
                <a className={styles.articleTitle} href={permalink} target="_blank">
                    {doc_name}
                </a>
                <div className={styles.userName}>
                    <a href={`${location.origin}/myComments?guid=${user_id}`} target="_blank">
                        {uname}
                    </a>
                    <span className={styles.location}>[{ip_from}网友]</span>
                </div>

                {parent && parent.length ? <div className={styles.parentCList}>{this.renderParent(parent)}</div> : null}
                <p className={styles.contentTxt} dangerouslySetInnerHTML={{ __html: contents }} />
                <div className={styles.bottomBar}>
                    <span className={styles.commentDate}>{comment_date}</span>
                    <div className={styles.replayBtn} onClick={this.handleShowInput}>
                        {showCommentInput ? '取消' : '回复'}
                    </div>
                </div>
                {showCommentInput ? (
                    <div className={styles.commentInput}>
                        <CommentTextarea
                            loginId={loginId}
                            config={commentConfig}
                            userInfo={userInfo}
                            myComUrl={myComUrl}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

class CommentsList extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        userInfo: PropTypes.object,
        myComUrl: PropTypes.string,
        loginId: PropTypes.string,
    };

    render() {
        const { content, userInfo, myComUrl, loginId } = this.props;

        return content.length ? (
            <div className={styles.commentList}>
                {content.map((itemComment, index) => (
                    <CommentItem
                        content={itemComment}
                        key={index}
                        userInfo={userInfo}
                        myComUrl={myComUrl}
                        loginId={loginId}
                    />
                ))}
            </div>
        ) : (
            <div className={styles.zanw}>暂无评论，欢迎发表您的观点</div>
        );
    }
}

export default errorBoundary(CommentsList);
